














































































































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  Ref,
  ref,
} from '@vue/composition-api';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import {
  getCustomers,
  getJob,
  getLatestJob,
  createJob,
  updateJob,
} from '@/api/index';
import useCost from '@/use/useCost';
import useAuth from '@/use/useAuth';
import { Budget, BudgetInput } from '@/types/budget';
import useJobStatus from '@/use/useJobStatus';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import BomBudgetInput from '@/components/Job/BomBudgetInput.vue';
import PanelWithSubJobUpload from '@/components/Job/PanelWithSubJobUpload.vue';

const PanelWithJobEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
    BomBudgetInput,
    PanelWithSubJobUpload,
  },
  props: {
    edit: { default: false },
  },
  setup(props, { root }) {
    const { route, router } = useRouter();
    const { hasPermission: checkPermissionHandler } = useAuth();
    const { dateDifferenceDisplay } = useJobStatus();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const { defaultCostType } = useCost();
    const budgetEditable = ref(true);
    const toCurrencyWithoutSign = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const successModal = ref(null);
    const getCustomerResult = (data: any) => data.data.data;
    const NOW = useFormat.date().computerShortDate();

    const latestJob = ref({ code: '' });

    const form = reactive({
      id: -1,
      code: '',
      name: '',
      machineName: '',
      reporterName: '',
      processName: '',
      machineCode: '',
      customer: null,
      quotation: '',
      type: 'AUTOMATION',
      amount: '1',
      unit: '',
      customer_po: '',
      isAssembly: true,
      targetDate: NOW,

      dueDesign: NOW,
      duePurchase: NOW,
      dueProduction: NOW,
      dueAssembly: NOW,
      dueProgram: NOW,
      dueDelivery: NOW,
      dueBuyoff: NOW,

      call: async () => {
        if (props.edit) {
          const result = await updateJob(form.id, {
            reporterName: form.reporterName,
            name: form.name,
            machineName: form.machineName,
            machineCode: form.machineCode,
            processName: form.processName,
            targetDate: form.targetDate,
            quotation: form.quotation,
            costs: getBudgetsInput(),
            customerId: (form.customer as any)?.id,
            type: form.type,
            amount: parseInt(form.amount, 10),
            unit: form.unit,
            customer_po: form.customer_po,
            isAssembly: form.isAssembly,

            dueDesign: form.dueDesign,
            duePurchase: form.duePurchase,
            dueProduction: form.dueProduction,
            dueAssembly: form.dueAssembly,
            dueProgram: form.dueProgram,
            dueDelivery: form.dueDelivery,
            dueBuyoff: form.dueBuyoff,
          });
          if (result.success) {
            (successModal.value as any).compose({ action: 'ดูรายละเอียด', entity: ' Job ' });
            router.push({
              name: 'JobEdit',
              params: { id: result.data.id },
            });
          }
        } else {
          const result = await createJob({
            reporterName: form.reporterName,
            name: form.name,
            machineName: form.machineName,
            machineCode: form.machineCode,
            processName: form.processName,
            targetDate: form.targetDate,
            costs: getBudgetsInput(),
            quotation: form.quotation,
            customerId: (form.customer as any)?.id,
            type: form.type,
            amount: parseInt(form.amount, 10),
            unit: form.unit,
            customer_po: form.customer_po,
            isAssembly: form.isAssembly,

            dueDesign: form.dueDesign,
            duePurchase: form.duePurchase,
            dueProduction: form.dueProduction,
            dueAssembly: form.dueAssembly,
            dueProgram: form.dueProgram,
            dueDelivery: form.dueDelivery,
            dueBuyoff: form.dueBuyoff,
          });
          if (result.success) {
            (successModal.value as any).compose({ action: 'บันทึก', entity: ' Job ' });
            router.push({
              name: 'JobEdit',
              params: { id: result.data.id },
            });
          }
        }
      },
    });

    function clear() {
      form.code = '';
      form.name = '';
      form.machineName = '';
      form.reporterName = '';
      form.processName = '';
      form.machineCode = '';
      form.customer = null;
      form.quotation = '';
      form.type = 'AUTOMATION';
      form.amount = '1';
      form.unit = 'pcs.';
      form.targetDate = NOW;
      form.customer_po = '';
      form.isAssembly = true;

      form.dueDesign = NOW;
      form.duePurchase = NOW;
      form.dueProduction = NOW;
      form.dueAssembly = NOW;
      form.dueProgram = NOW;
      form.dueDelivery = NOW;
      form.dueBuyoff = NOW;
    }

    // ======= Budget Computed ============
    const budgets: Ref<Budget[]> = ref(defaultCostType);
    function getBudgetsInput() {
      return budgets.value.map((budget: Budget) => {
        const output: { id: number | null; name: string; cost: number; category: string; } = {
          id: null,
          name: budget.name,
          cost: parseFloat(budget.cost as string) || 0,
          category: budget.category,
        };
        if (typeof budget?.id === 'number' && budget?.id) output.id = budget.id;
        return output;
      }).filter((budget: BudgetInput) => ((budget.cost !== 0 || (form.id !== -1 && budget.id)) && budget.name !== '') || (budget.name === 'FAB' || budget.name === 'EE' || budget.name === 'ME' || budget.name === 'SCREW'));
    }

    const totalBudget = computed(() => {
      let budget = 0;
      budgets.value.forEach((expense: Budget) => {
        budget += parseFloat(expense.cost as string) || 0;
      });
      return budget;
    });

    // ====== Format Budget result into Budget
    function resultToEditableBudget(budgetsArrayResult: Budget[]) {
      console.log(budgetsArrayResult);
      const result: Budget[] = defaultCostType;
      const hitIndex: number[] = [];
      budgetsArrayResult.forEach((budgetResult: Budget, budgetIndex: number) => {
        result.forEach((budget: Budget, index: number) => {
          if (budget.name === budgetResult.name) {
            if (hitIndex.indexOf(budgetIndex) === -1) hitIndex.push(budgetIndex);
            result.splice(index, 1, {
              ...budgetResult,
              lock: true,
            });
          }
        });
      });

      budgetsArrayResult.forEach((budgetResult: Budget, budgetIndex: number) => {
        if (hitIndex.indexOf(budgetIndex) === -1) result.push(budgetResult);
      });

      return result;
    }

    function uploadSubJobDoneHandler(event: any) {
      (successModal.value as any).compose({
        action: 'บันทึก',
        entity: 'Sub Job',
        data: event,
        primaryAction: 'ดูรายละเอียด Job',
      });
    }
    function navigateToCreatePurchaseRequest(ctx: any) {
      const search = ctx.data.map((elm: any) => elm.bom_item_id);
      router.push({
        name: 'PurchaseRequestCreateProductionWithBomId',
        params: { bomId: route.value.params.id },
        query: {
          instantSearch: search,
        },
      });
    }

    // ====================================

    onMounted(async () => {
      // expenseTypes.value = await getExpenseTypes({});
      if (props.edit) {
        const result = (await getJob(route.value.params.id)).data;
        form.id = route.value.params.id;
        form.name = result.name;
        form.code = result?.code || '';
        form.machineName = result.machine_name;
        form.reporterName = result.reporter_name;
        form.customer = result.customer;
        form.quotation = result.quotation;
        form.targetDate = result.target_date;

        form.type = result.type;
        form.amount = result.amount;
        form.unit = result.unit;
        form.customer_po = result.customer_po;

        form.isAssembly = result.is_assembly;

        budgets.value = resultToEditableBudget(result.costs);

        form.dueDesign = result.due_design;
        form.duePurchase = result.due_purchase;
        form.dueProduction = result.due_production;
        form.dueAssembly = result.due_assembly;
        form.dueProgram = result.due_program;
        form.dueDelivery = result.due_delivery;
        form.dueBuyoff = result.due_buyoff;
      }

      latestJob.value = await getLatestJob();
    });

    return {
      hasPermission,
      dateDifferenceDisplay,

      toCurrencyWithoutSign,
      successModal,
      getCustomerResult,
      getCustomers,
      form,
      budgets,
      budgetEditable,
      totalBudget,
      clear,
      uploadSubJobDoneHandler,
      navigateToCreatePurchaseRequest,
      latestJob,
    };
  },
});

export default PanelWithJobEditor;
